import * as React from 'react'
import { Button, Col, Input, List, PageHeader, Row } from 'antd'
import { PlusOutlined, TeamOutlined } from '@ant-design/icons'

import { TTAvatar } from '../shared/TTAvatar'
import { PagedBaseState } from '../../models/PagedBaseState'
import { UtenteModel } from '../../models/UtenteModels'
import { SearcherBaseModel } from '../../models/SearcherBaseModel'
import { ProjectionPagedModel } from '../../models/ProjectionPageModel'

const { Search } = Input

class UtentiState extends PagedBaseState<UtenteModel> { }

interface ListUtentiProps {
    title: string
    onUtenteClick: (id: string) => void
    onUtenteNewClick: () => void
    onSearch: (model: SearcherBaseModel) => Promise<ProjectionPagedModel<UtenteModel>>
}

export class ListUtenti extends React.Component<ListUtentiProps, UtentiState> {

    constructor(props) {
        super(props)
        this.state = new UtentiState()
    }

    componentDidMount() {
        this.search(1)
    }

    onSearch = text => {
        this.setState({ Searcher: text })
        this.search(1)
    }

    onPageChange = page => {
        this.search(page)
    }

    search = async (page: number) => {
        const searcher: SearcherBaseModel = {
            Pagina: page,
            FullText: this.state.Searcher,
            Righe: 20
        }

        let resp = await this.props.onSearch(searcher)
        this.setState({ Data: resp, Page: page })
    }

    render() {
        return (
            <PageHeader title={this.props.title} extra={[
                <Button type="primary" key="edit-customer" icon={<PlusOutlined />} onClick={() => this.props.onUtenteNewClick()}>Crea</Button>
            ]}>
                <Row>
                    <Col offset={1} span={22}>
                        <Search placeholder="Cerca utente"
                            onSearch={value => this.onSearch(value)}
                            value={this.state.Searcher}
                            onChange={e => this.setState({ Searcher: e.target.value })}
                            enterButton />
                    </Col>
                </Row>
                <br />
                <List
                    dataSource={this.state.Data.Data}
                    rowKey={it => it.Id}
                    pagination={{
                        onChange: (page) => this.onPageChange(page),
                        pageSize: 20,
                        total: this.state.Data.Total,
                        current: this.state.Page
                    }}
                    renderItem={item => (
                        <List.Item key={item.Id}>
                            <List.Item.Meta
                                avatar={<TTAvatar icon={<TeamOutlined />} />}
                                title={<a onClick={() => this.props.onUtenteClick(item.Id)}>{item.Nominativo}</a>}
                                description={item.Email}
                            />
                        </List.Item>
                    )} />
            </PageHeader>
        )
    }
}